/**
 * LocalStorage Service
 * Provides typed storage operations for the prototype
 * Replaces AsyncStorage from React Native with browser localStorage API
 */

const STORAGE_KEYS = {
  INTENTIONS: 'user:intentions',
  BIRTH_DETAILS: 'user:birthDetails',
  AFFIRMATIONS: 'user:affirmations',
  GROWTH_DATA: 'user:growthData',
  BLUEPRINTS: 'user:blueprints',
  SPOTLIGHT_INTENTION: 'user:spotlightIntention',
  USER_PROFILE: 'user:profile',
} as const;

export class LocalStorage {
  /**
   * Get item from localStorage
   */
  static getItem<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error reading from localStorage key "${key}":`, error);
      return null;
    }
  }

  /**
   * Set item in localStorage
   */
  static setItem<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error writing to localStorage key "${key}":`, error);
    }
  }

  /**
   * Remove item from localStorage
   */
  static removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing localStorage key "${key}":`, error);
    }
  }

  /**
   * Clear all localStorage
   */
  static clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }

  /**
   * Get storage keys
   */
  static getKeys() {
    return { ...STORAGE_KEYS };
  }
}

export default LocalStorage;
